import React, { ReactNode } from "react";

const INLINE_MD_RE = /(\*\*(.+?)\*\*|~~(.+?)~~|__(.+?)__|\*(.+?)\*)/g;

const formatSegment = (
  match: string,
  bold?: string,
  strike?: string,
  underline?: string,
  italic?: string,
): ReactNode => {
  if (bold) return <strong>{bold}</strong>;
  if (strike) return <s>{strike}</s>;
  if (underline) return <u>{underline}</u>;
  if (italic) return <em>{italic}</em>;
  return match;
};

const processText = (text: string): ReactNode => {
  const parts: ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  INLINE_MD_RE.lastIndex = 0;
  while ((match = INLINE_MD_RE.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    parts.push(
      <React.Fragment key={match.index}>
        {formatSegment(match[0], match[2], match[3], match[4], match[5])}
      </React.Fragment>,
    );
    lastIndex = INLINE_MD_RE.lastIndex;
  }
  if (lastIndex === 0) return text;
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return parts;
};

const renderChildren = (node: ReactNode): ReactNode => {
  if (typeof node === "string") return processText(node);
  if (React.isValidElement(node) && node.props.children) {
    return React.cloneElement(
      node,
      { ...node.props },
      React.Children.map(node.props.children as ReactNode, renderChildren),
    );
  }
  return node;
};

const InlineMarkdown = ({ children }: { children: ReactNode }) => (
  <>{React.Children.map(children, renderChildren)}</>
);

export default InlineMarkdown;
